<template>
  <div
    v-bind:class="['toggleable-text', toggleableTextClass]"
  >
    <div
      class="toggleable-text__text"
      ref="text"
      v-bind:style="hideHeight ? { maxHeight: `${isShowed ? totalHeight : hideHeight}px` } : {}"
      v-html="text"
    />
    <div
      v-if="showButtons"
      v-bind:class="['toggleable-text__button', isShowed ? 'toggleable-text__button--show' : 'toggleable-text__button--hide']"
      v-on:click="onClick"
    >
      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.66659 6.55013L6.99992 1.2168L12.3333 6.55013" stroke="#94B1BF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ isShowed ? $t('zabalit') : $t('rozbalit') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleableText',
  props: {
    toggleableTextClass: String,
    text: String,
  },
  data: () => {
    return {
      isShowed: false,
      showButtons: false,
      totalHeight: 0,
      hideHeight: 0,
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      const el = document.createElement('div');
      el.innerHTML = this.$refs.text.innerHTML;
      this.$refs.text.parentElement.append(el);

      const styles = window.getComputedStyle(el);
      const lineHeight = parseInt(styles.lineHeight);
      const numberOfLines = el.clientHeight / lineHeight;

      if (!lineHeight || !numberOfLines) {
        return;
      }

      this.showButtons = numberOfLines > 4;
      this.totalHeight = el.clientHeight;
      this.hideHeight = 4 * lineHeight;

      el.parentElement.removeChild(el);
    },
    onClick() {
      this.isShowed = !this.isShowed;
    },
  }
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/functions.scss';

.toggleable-text {
  &__text {
    overflow: hidden;
    transition: max-height 500ms;
  }

  &__button {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    line-height: 150%;
    color: $baliLight;
    margin-top: 6px;
    cursor: pointer;

    svg {
      margin-right: 15px;
      transition: transform 500ms;
    }

    &--hide {
      svg {
        transform: rotate(180deg);
      }
    }

    @include media-breakpoint-up(md) {
      font-size: 16px;
      line-height: 150%;
    }
  }
}
</style>
